import api from 'services/api'

import type {
  EdiDeleteParams,
  EdiSendBody,
  EdiSendResponse,
  EdiUploadReturn,
  EdiVersion,
  FranchiseUploadResponse,
  IntlEDI,
} from './interfaces'

export const getEdiList = async () => {
  const response = await api.get<IntlEDI[]>(`rascunho/v2/GetEdiTipo`)
  return response.data
}

export const getEdiVersionList = async (idEDI: string) => {
  const response = await api.get<EdiVersion[]>(`rascunho/v2/GetEdiVersao`, {
    params: { cd_edi: idEDI },
  })
  return response.data
}

export const uploadEdiFile = async (params: FormData, setProgress?: (progress: number) => void) => {
  const response = await api.post<EdiUploadReturn>(`rascunho/v2/upload-pedido-edi`, params, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
    onUploadProgress(progressEvent) {
      const percentCompleted = progressEvent.total
        ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
        : 0
      if (setProgress) setProgress(percentCompleted)
    },
  })

  return response.data
}

export const deleteEdiUploadAsync = async (body: EdiDeleteParams) => {
  const response = await api.delete(`rascunho/v2/DeleteEdiProcessamento`, { data: body })

  return response.data
}

export const asyncSendEdiOrder = async (body: EdiSendBody) => {
  const response = await api.post<EdiSendResponse>(`rascunho/v2/EnvioPedidoEdi`, body)

  return response.data
}

export const uploadFranchiseFile = async (
  params: FormData,
  setProgress?: (progress: number) => void,
) => {
  const response = await api.post<FranchiseUploadResponse>(
    `rascunho/v2/upload-planilha-pedido-em-massa`,
    params,
    {
      headers: {
        'Content-Type': 'multipart/form-data',
      },
      onUploadProgress(progressEvent) {
        const percentCompleted = progressEvent.total
          ? Math.round((progressEvent.loaded * 100) / progressEvent.total)
          : 0
        if (setProgress) setProgress(percentCompleted)
      },
    },
  )

  return response.data
}

export const deleteFranchiseUploadAsync = async (filename: string) => {
  const response = await api.delete(`rascunho/v2/delete-pedido-em-massa?nm_arqv_upld=${filename}`)

  return response.data
}

export const asyncSendFranchiseOrder = async (filename: string) => {
  const response = await api.post(`order/v2/confirmacao-massa?nomeArquivo=${filename}`)

  return response
}
